import React from 'react'
import HeroSection from './Components/HeroSection';
import { useGlobalContext } from './context';
import { useEffect } from 'react';
import Services from "./Services";
import Contact from "./Contact";


const Home = () => {
  
  // const data ={
  //   tdata: "This is Us",
  //   name: "Colglin",
  //   image: "./photos/hero.jpg"
  // }

  const {updateHomePage} = useGlobalContext();
  useEffect (()=>{
    updateHomePage();
  }, []);
  return (
    <>
        <HeroSection/>
        <Services/>
        <Contact/>
    </>
  )
}

export default Home